import {
  faArrowLeft,
  faBell,
  faComments,
  faEllipsisVertical,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState ,useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import TopbarSearch from "../Sidebar/TopbarSearch";
import i18n from "i18next";
import { getAllPost, getGameFromSlug, getProfile, getProfileImage, searchStocksApi } from "../../api/user";
import { toast } from "react-toastify";

function DashboardHeader({ searchVal, toggle, setStocksData, setLoader,game }) {

  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const { slug } = useParams();
  const navigate = useNavigate();
  const game_id = null;
  const pathSegments = window.location.pathname.split("/");
  const isSlugPostsPath = location.pathname.includes("/posts");
  const isTradingDetail = /^\/trading-detail\/\d+\/\d+/.test(location.pathname);
  // const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(false);
  // const hideOnPaths = ["/contest", "/contest/my-games", "/contest/add-game","/contest/game-detail/:id"];
  // const shouldHideTopbarSearch = hideOnPaths.includes(location.pathname);

  const validPaths = ["feeds", "buysell", "charts", "portfolio", "leaderboard"];

  // Extract the second segment of the path
  const pathSegment = location.pathname.split("/")[2];

  // Check if the second segment matches any of the valid paths
  const isValidPath = validPaths.includes(pathSegment);

  const hideOnPaths = [
    //"/contest",
    //"/contest/my-games",
    // "/contest/add-game",
    //  /\/contest\/game-detail\/\d+/ // Use regex to match game-detail paths with numeric IDs
  ];

const pathSegments2 = location.pathname.split("/");
  const shouldHideForm =
    pathSegments2[1] === "buysell" && (!pathSegments2[2] || /^\d+$/.test(pathSegments2[2])) ||
    pathSegments2[1] === "charts";

  // Check if the current path should hide the top bar search
  const shouldHideTopbarSearch = hideOnPaths.some((route) => {
    if (typeof route === "string") {
      return route === location.pathname; // Exact match for string paths
    } else if (route instanceof RegExp) {
      return route.test(location.pathname); // Check against regex for dynamic paths
    }
    return false;
  });

  // Example usage
  if (shouldHideTopbarSearch) {
    console.log("Topbar search should be hidden.");
  } else {
    console.log("Topbar search should be visible.");
  }

  const [scButton, setScButton] = useState(false);
  const [selectedLanguageOption, setSelectedLanguageOption] = useState("en");

  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : "";

  const [number, SetNumber] = useState(
    localStorage.getItem("notificationCount")
      ? localStorage.getItem("notificationCount")
      : userInfo?.device_info?.badge
  );

  const [messageCount, setMessageCount] = useState(
    localStorage.getItem("messageCount")
      ? localStorage.getItem("messageCount")
      : userInfo?.device_info?.message_count
  );

  const [avtar, setAvtar] = useState();

  const [search, setSearch] = useState(searchVal ? searchVal : "");
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [apiCalled, setApiCalled] = useState(false);
  const [category, setCategory] = useState('Stocks');


    const fetchProfile = async (userInfo) => {
        try {
            let response;
            if (userInfo) {
                response = await getProfileImage(userInfo.id, game_id);
            }
            if (response?.data?.data) {
                const profileData = response.data.data;
                if (profileData) {
                    localStorage.setItem(
                        "userInfo",
                        JSON.stringify(profileData)
                    );
                    localStorage.setItem("img", profileData.image);
                    setAvtar(localStorage.getItem("img") ? localStorage.getItem("img") : "");
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };


    //   useEffect(() => {

    //     const checkGameDates = (start_date, end_date) => {

    //         const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
    //         const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
    //         const today = new Date(); // Get today's date
    //         today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

    //         if (today >= startDate && today <= endDate) {
    //             return true;
    //         } else {
    //             return false;
    //         }

    //     }

    //     const fetchGameId = async (slug) => {
    //         try {
    //             const response = await getGameFromSlug({ slug });
    //             const gameData = response?.data?.data;
    //             if (gameData) {
    //                 //if(checkGameDates(gameData.start_date, gameData.end_date)){
    //                     setGame(gameData);
    //                     setLoading(true);
    //               //  }
    //               //  else{
    //                   //  toast.error("League is not active");
    //                     // navigate("/contest/my-games");
    //                     // navigate("/contest/my-games", { state: { viewMode: "creator" } });
    //               //  }
    //             } else {
    //                 // toast.error("League not found");
    //                 // navigate("/contest/my-games");
    //                 // navigate("/contest/my-games", { state: { viewMode: "member" } });
    //             }
    //         } catch (error) {
    //             console.error("Error fetching game ID:", error);
    //         }
    //     };

    //     fetchGameId(slug);

    // }, [slug]);


  useEffect(() => {
    localStorage.setItem("searchItem", search);
  }, [search]);

  useEffect(() => {
    // setAvtar(userInfo?.image);
    // localStorage.setItem("img", userInfo?.image);
    fetchProfile(userInfo);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      setAvtar(event?.detail?.profileImg);
    };
    window.addEventListener("profileEvent", handleCustomProfileEvent);
  }, [window.addEventListener]);

  useEffect(() => {
    const handleCustomEvent = (event) => {
      setMessageCount(event.detail.messageCount);
      SetNumber(event.detail.notificationCount);
    };

    window.addEventListener("myCustomEvent", handleCustomEvent);
  }, [window.addEventListener]);

  useEffect(() => {
    if (!isDataFeteched) searchAPi();
    if (
      window.location.pathname === "/search" ||
      window.location.pathname === "/auth/trending-stocks" ||
      window.location.pathname !== "/charts" ||
      window.location.pathname !== "/buysell" ||
      location.pathname !== `/${slug}/buysell` ||
      location.pathname !== `/${slug}/charts`
    ) {
      setSearch("");
    } else if (window.location.pathname === "/feed" || window.location.pathname === `/${slug}/feeds`) {
      setSearch("");
    } else if (window.location.pathname.includes("/feeds")) {
  // Handle slug/posts path
  setSearch("");
}
  }, [isDataFeteched]);
const searchRef = useRef("");

  const handleChange = (e) => {
    if(!shouldHideForm){
     setSearch(e.target.value);
    }else{
      // alert('in change');
      // alert(e);

        const value = e;
  searchRef.current = value;
  setSearch(value);
    }
  };

  const handleCategory = (cat) => {
    setCategory(cat);
  }

  const handleSubmit = (e) => {
  const query = searchRef.current;
  // alert("for desktop");
  // alert(query);
  //  e.preventDefault();
    searchAPi();
    if (
      search &&
      window.location.pathname !== "/feed" &&
      !window.location.pathname.includes("/feeds") &&
      window.location.pathname !== "/search" &&
      window.location.pathname !== "/charts" &&
      window.location.pathname !== "/buysell" &&
      location.pathname !== `/${slug}/buysell` &&
      location.pathname !== `/${slug}/charts`
    ) {
      navigate(`/search/${search}`);
    }
  };

  const searchAPi = async () => {
    try {
      let res;
      let res1;
      let res2;

      if (search && window.location.pathname === "/feed" || window.location.pathname.includes("/feeds")  || window.location.pathname === `/${slug}/feeds`) {

        // setLoader(true);
        console.log(search,'search is  ----------------------------------- ');
        console.log(typeof search, 'Type of search');
        res = await getAllPost(search || "");
        console.log(res,'res is ---');
        if (res?.data?.data?.data) {
          setisDataFeteched(true);
          setApiCalled(false);
          setStocksData(res?.data?.data.data);
        } else if (res?.data?.data.length === 0) {
          // toast.error(`No stocks found for this keyword`);
          toast.error('No recent data available. This ticker has very low trading activity');
        } else {
          toast.error("Something went wrong, please refresh the screen");
        }

        if (res?.data?.data?.game_notification > 0) {
          localStorage.setItem(
            "notificationCount",
            res?.data?.data?.game_notification
          );
        }
        setLoader(false);
      } else {
          const rawQuery = searchRef.current; // get and trim user input
          let formattedQuery = rawQuery;
            if (category === "Forex") {
            if (!formattedQuery.startsWith("C:")) {
              formattedQuery = `C:${formattedQuery}`;
            }
          } else if (category === "Crypto") {
            if (!formattedQuery.startsWith("X:")) {
              formattedQuery = `X:${formattedQuery}`;
            }
          }
        const query =formattedQuery;
        if (
          (!apiCalled && window.location.pathname === "/search") ||
          window.location.pathname === "/auth/trending-stocks"
        ) {
          setApiCalled(true);
          setLoader(true);
          res1 = await searchStocksApi({ search: search.toUpperCase() || "", category: category,});;
          if (res1 && res1?.data.status === 200) {
            setisDataFeteched(true);
            setStocksData(res1?.data?.data);
          } else if (res1?.data?.data.length === 0) {
            toast.error("No Stock Found");
          } else {
            toast.error("Something went wrong, please refresh the screen");
          }
          setApiCalled(false);
          setLoader(false);
        } else if (
          !apiCalled &&
          location.pathname !== `/${slug}/buysell` &&
          location.pathname !== `/${slug}/charts` &&
          pathSegments[2]
        ) {
          if (pathSegments[1] === "search") {
            setLoader(true);
          }
          setApiCalled(true);
          if (search.length > 0) {
            res1 = await searchStocksApi({ search: query.toUpperCase() || "", category: category,});;
            if (res1 && res1?.data.status === 200) {
              setisDataFeteched(true);
              if (pathSegments[1] === "search") {
                setStocksData(res1?.data?.data);
              }
            } else if (res1?.data?.data.length === 0) {
          //    toast.error(`No stocks found for this keyword`);
          toast.error('No recent data available. This ticker has very low trading activity');
            } else {
              toast.error("Something went wrong, please refresh the screen");
            }
          }
          setApiCalled(false);
          setLoader(false);
        } else if (
          !apiCalled &&
          search &&
          (window.location.pathname === "/charts" ||
            window.location.pathname === "/buysell" ||
            location.pathname === `/${slug}/buysell` ||
            location.pathname === `/${slug}/charts`)
        ) {
          setLoader(true);
          res2 = await searchStocksApi({ search: query.toUpperCase() || "", category: category,});
          if (res2?.data?.data.length > 0) {
            localStorage.setItem("ticker", query);
            // localStorage.setItem("category", category);
            const myCustomEvent = new CustomEvent("tickerEvent", {
              detail: {
                ticker: res2?.data?.data[0]?.stock_symbol,
              },
            });
            window.dispatchEvent(myCustomEvent);
            setisDataFeteched(true);
          } else if (res2?.data?.data.length === 0) {
          //  toast.error(`No stocks found for this keyword`);
          toast.error('No recent data available. This ticker has very low trading activity');
          } else {
            toast.error("Something went wrong, please refresh the screen");
          }
          setApiCalled(false);
          setLoader(false);
        }
      }
    } catch (error) {
      // console.log("An error occurred: " + error.message);
    }
  };

  const clearSearch = () => {
    search.current.value = "";
    setScButton(false);
  };

  useEffect(() => {
    i18n.changeLanguage(selectedLanguageOption);
  }, [selectedLanguageOption]);

  const showAllIcons = () => (
    <div className="flex items-center gap-2">
      <Link
        to="/notifications"
        className="flex items-center gap-4 relative"
        style={{ width: "24px", height: "24px" }}
      >
        <img
          style={{ width: "22px", height: "26px" }}
          src={require("../../images/notification-qushi.png")}
          alt="Avatar"
        />
        {/* <FontAwesomeIcon
          icon={faBell}
          style={{ width: "24px", height: "24px" }}
        /> */}
        {number > 0 && (
          <span className="notification-count absolute top-[-8px] right-[-8px] flex items-center justify-center">
            {/* <FontAwesomeIcon icon={faBell} className="text-white text-xs font-bold" /> */}
            <span
              className={`
            count bg-primaryColor text-white text-xs font-bold rounded-full  ml-1 ${
              number > 9 ? "px-2 py-1" : "px-2 py-0.5"
            }`}
            >
              {number}
            </span>
          </span>
        )}
      </Link>
      <Link
        to="/chat"
        className="flex items-center gap-4 relative"
        style={{ width: "24px", height: "24px" }}
      >
        <img
          style={{ width: "26px", height: "26px" }}
          src={require("../../images/msg-qushi.png")}
          alt="Avatar"
        />
        {messageCount > 0 && (
          <span className="notification-count absolute top-[-8px] right-[-8px] flex items-center justify-center">
            {/* <FontAwesomeIcon icon={faBell} className="text-white text-xs font-bold" /> */}
            <span
              className={`count bg-primaryColor text-white text-xs font-bold rounded-full px-2 py-0.5 ml-1 ${
                messageCount > 9 ? "px-2 py-1" : "px-2 py-0.5"
              }`}
            >
              {window.location.pathname === "/chat" ? (
                <FontAwesomeIcon icon={faPlus} />
              ) : (
                messageCount
              )}
            </span>
          </span>
        )}
      </Link>
      <p
        className="flex items-center gap-4 relative flex-center"
        onClick={toggle}
      >
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          style={{ width: "24px", height: "24px" }}
        />
      </p>
    </div>
  );

  const showChatAndToggleOnly = () => (
    <div className="flex items-center cursor-pointer mr-[10px]">
      <Link
        to="/chat"
        className={messageCount > 0 ? "mr-4 relative" : "mr-2 relative"}
      >
        <img
          style={{ width: "26px", height: "26px" }}
          src={require("../../images/msg-qushi.png")}
          alt="Avatar"
        />
        {/* <FontAwesomeIcon icon={faComments}></FontAwesomeIcon> */}
        {messageCount > 0 && (
          <span className="notification-count absolute top-[-8px] right-[-8px] flex items-center justify-center">
            {/* <FontAwesomeIcon icon={faBell} className="text-white text-xs font-bold" /> */}
            <span className="count bg-primaryColor text-white text-xs font-bold rounded-full px-1 ml-1">
              {window.location.pathname === "/chat" ? (
                <FontAwesomeIcon icon={faPlus} />
              ) : (
                messageCount
              )}
            </span>
          </span>
        )}
      </Link>
      <p
        className="flex items-center gap-4 relative flex-center"
        onClick={toggle}
      >
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          style={{ width: "24px", height: "24px" }}
        />
      </p>
    </div>
  );

  const showToggleOnly = () => (
    <>
      <p
        className="cursor-pointer md:hidden text-2xl ml-[3rem] mr-[3px]"
        onClick={toggle}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </p>
    </>
  );
  useEffect(() => {
    // Check if the URL contains '/:slug/' pattern
    const isDynamicRoute =
      /\/[^/]+\/(buysell|portfolio|leaderboard|profile|charts|feeds|chatHistory|create-feed|edit-feed|followers)/.test(
        location.pathname
      );
    setIsCollapsed(isDynamicRoute);
  }, [location]);
  // const isChartsPath = location.pathname === "/charts";
  const isChartsPath = location.pathname.endsWith("/charts");

  return (

    <>
      <div
        className={`${
          isMobileView
            ? `${
                window.location.pathname == "/feed"
                  ? "border-none px-2 border-white sm:px-8 sm:mb-2 mb-0 py-1 flex justify-between items-center flex-wrap w-full bg-white bottom-shadow "
                  : "px-2 sm:px-8 sm:mb-2 mb-0 py-1 flex justify-between items-center flex-wrap w-full bg-white bottom-shadow border-none"
              }`
            : "px-3 sm:pr-8 sm:mb-2 mb-0 py-3 flex flex-wrap w-full justify-between items-center bg-white bottom-shadow"
        }`}
        style={{ position: "fixed", minHeight: "50px", zIndex: "10" }}
      >
        {/* old */}
        {/* <div
        className={`hidden md:flex md:flex-1 ${
          isCollapsed ? "ml-20" : "ml-64"
        }`}
      >
        {!shouldHideTopbarSearch && (
          <TopbarSearch
            clearSearch={clearSearch}
            handleChange={handleChange}
            scButton={scButton}
            search={search}
            handleSubmit={handleSubmit}
          />
        )}
      </div> */}

        {/* new */}
        <div
          className={`${
            isChartsPath && !isMobileView ? "" : "hidden"
          } md:flex md:flex-1 ${isCollapsed ? "ml-20" : "ml-64"}`}
        >
          {!shouldHideTopbarSearch && (
            <TopbarSearch
              clearSearch={clearSearch}
              handleChange={handleChange}
              handleCategory={handleCategory}
              scButton={scButton}
              search={search}
              handleSubmit={handleSubmit}
            />
          )}
        </div>

        <div className="ml-1">
          {isMobileView &&
          (window.location.pathname == "/leaderboard" ||
            window.location.pathname == "/contest" ||
            window.location.pathname == "/trading-floor" ||
            window.location.pathname == "/contest/my-games" ||
            window.location.pathname == "/contest/cash-leagues" ||
            window.location.pathname == "/contest/add-league" ||
            window.location.pathname == `/contest/${slug}/edit` ||
            /\/contest\/game-detail\/\d+$/.test(window.location.pathname) ||
            /^\/contest\/[^/]+$/.test(window.location.pathname) ||
            window.location.pathname == "/auth/trending-stocks" ||
            window.location.pathname == "/market-sentiment" ||
            window.location.pathname == "/profile" ||
            window.location.pathname == "/performance" ||
            window.location.pathname == "/followers" ||
            window.location.pathname == "/chatHistory" ||
            window.location.pathname == "/chat" ||
            window.location.pathname == "/subscriptions" ||
            window.location.pathname == "/notifications" ||
            window.location.pathname == "/settings" ||
            window.location.pathname == "/search" ||
            pathSegments[1] === "profile" ||
            pathSegments[1] === "performance" ||
            pathSegments[1] === "followers" ||
            window.location.pathname == "/saved-post" ||
            pathSegments[1] === "chartSearch" ||
            window.location.pathname == "/edit-profile" ||
            pathSegments[1] === "edit-post" ||
            // pathSegments[1] === "buysell" ||
            pathSegments[1] === "portfolio" ||
            pathSegments[1] === "chatHistory" ||
            window.location.pathname == "/create-post" ||
            window.location.pathname == "/change-password") ? (
            <p
              onClick={() => {
                if (
                  window.location.pathname == "/leaderboard" ||
                  window.location.pathname == "/contest" ||
                  window.location.pathname == "/trading-floor" ||
                  window.location.pathname == "/contest/my-games" ||
                  window.location.pathname == "/contest/cash-leagues" ||
                  window.location.pathname == "/contest/add-league" ||
                  window.location.pathname == `/contest/${slug}/edit` ||
                  /\/contest\/game-detail\/\d+$/.test(
                    window.location.pathname
                  ) ||
                  /^\/contest\/[^/]+$/.test(window.location.pathname) ||
                  window.location.pathname == "/auth/trending-stocks" ||
                  window.location.pathname == "/market-sentiment" ||
                  window.location.pathname == "/create-post" ||
                  window.location.pathname == "/chat" ||
                  window.location.pathname == "/settings" ||
                  window.location.pathname == "/subscriptions" ||
                  window.location.pathname == "/notifications" ||
                  window.location.pathname == "/chatHistory" ||
                  window.location.pathname == "/buysell" ||
                  window.location.pathname == "/search" ||
                  pathSegments[1] === "profile" ||
                  pathSegments[1] === "performance" ||
                  pathSegments[1] === "followers" ||
                  window.location.pathname == "/saved-post" ||
                  window.location.pathname == "/charts" ||
                  window.location.pathname == "/profile" ||
                  window.location.pathname == "/performance" ||
                  window.location.pathname == "/followers" ||
                  window.location.pathname == "/edit-profile" ||
                  pathSegments[1] === "edit-post" ||
                  pathSegments[1] === "buysell" ||
                  pathSegments[1] === "portfolio" ||
                  pathSegments[1] === "chartSearch" ||
                  pathSegments[1] === "chatHistory" ||
                  window.location.pathname == "/cliff-notes" ||
                  window.location.pathname == "/change-password"
                ) {
                  navigate(-1);
                }
              }}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={{ width: "17px", height: "17px" }}
              />
            </p>
          ) : (
            <p className="flex-shrink-0 rounded-full block md:hidden border shadow-lg">
              <Link to="/profile">
                <img
                  className="rounded-full object-cover md:h-10 md:w-10 h-10 w-10 border cursor-pointer"
                  style={{ width: "34px", height: "34px" }}
                  // src={avtar || localStorage.getItem("img") || "/qushi_logo.png"}
                  src={
                    isTradingDetail || !avtar && !localStorage.getItem("img")
                      ? "/qushi_logo.png"
                      : avtar || localStorage.getItem("img") || "/qushi_logo.png"
                  }
                  alt="Avatar"
                />
              </Link>
            </p>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            left: "50%",
            transform: "translate(-50%, -50%)",
            top: "50%",
          }}
        >
          <p className="md:hidden">
            <div
              style={{
                display: "grid",
                justifyItems: "center",
                alignItems: "center",
              }}
              className="flex-center"
            >
              <img
                className="w-28"
                style={{
                  width: "84px",
                  height: "21px",

                  marginRight:
                    window.location.pathname === "/edit-profile"
                      ? "0px"
                      : "0px",
                }}
                src={require("../../images/log2.png")}
                alt="Avatar"
              />
              {isMobileView && window.location.pathname == "/leaderboard" ? (
                <span className="flex-center text-black font-samibold">
                  Leaderboard
                </span>
              ) : isMobileView && window.location.pathname == "/contest" ? (
                <span className="flex-center text-black font-samibold">
                  All Leagues
                </span>
              ) : isMobileView && window.location.pathname == "/trading-floor" ? (
                <span className="flex-center text-black font-samibold">
                  Trading Floor
                </span>
              ) : isMobileView &&
                window.location.pathname == "/contest/my-games" ? (
                <span className="flex-center text-black font-samibold">
                  My Leagues
                </span>
              ) : isMobileView &&
                window.location.pathname == "/contest/cash-leagues" ? (
                <span className="flex-center text-black font-samibold">
                  Cash Leagues
                </span>
              ) : isMobileView &&
                /^\/contest\/(?!add-league)[^/]+$/.test(
                  window.location.pathname
                ) ? (
                <span className="flex-center text-black font-samibold">
                  League Detail
                </span>
              ) : isMobileView &&
                window.location.pathname === "/contest/add-league" ? (
                <span className="flex-center text-black font-samibold">
                  Create League
                </span>
              ) : isMobileView &&
                window.location.pathname == `/contest/${slug}/edit` ? (
                <span className="flex-center text-black font-samibold">
                  Edit League
                </span>
              ): isMobileView &&
                window.location.pathname === `/${slug}/feeds` ? (
                <span className="flex-center text-black font-samibold">
                  {game ? game.title : "Feeds"}
                </span>
              )  : isMobileView &&
                window.location.pathname === `/${slug}/buysell` ? (
                <span className="flex-center text-black font-samibold">
                  {game ? game.title : "Buy/Sell"}
                </span>
              ) : isMobileView &&
                window.location.pathname === `/${slug}/charts` ? (
                <span className="flex-center text-black font-samibold">
                  {game ? game.title : "Charts"}
                </span>
              ) : isMobileView &&
                window.location.pathname === `/${slug}/create-feed` ? (
                <span className="flex-center text-black font-samibold">
                  {game ? game.title : "Create Post"}
                </span>
              ) : isMobileView &&
                window.location.pathname === `/${slug}/portfolio` ? (
                <span className="flex-center text-black font-samibold">
                  {game ? game.title : "Portfolio"}
                </span>
              ) : isMobileView &&
                window.location.pathname === `/${slug}/leaderboard` ? (
                <span className="flex-center text-black font-samibold">
                  {game ? game.title : "LeaderBoard"}
                </span>
              ) : isMobileView &&
                window.location.pathname == "/auth/trending-stocks" ? (
                <span className="flex-center text-black font-samibold">
                  Today’s Movers
                </span>
              ) : isMobileView &&
                window.location.pathname == "/market-sentiment" ? (
                <span className="flex-center text-black font-samibold">
                  Market Sentiment
                </span>
              ) : isMobileView && window.location.pathname == "/create-post" ? (
                <span className="flex-center text-black font-samibold">
                  Create Post
                </span>
              ) : isMobileView && window.location.pathname == "/chat" ? (
                <span className="flex-center text-black font-samibold">
                  Chats
                  {messageCount > 0 && (
                    <span className="ml-1 text-white bg-primaryColor rounded-full px-2 py-1 text-xs font-semibold">
                      {messageCount}
                    </span>
                  )}
                </span>
              ) : isMobileView && window.location.pathname == "/settings" ? (
                <span className="flex-center text-black font-samibold">
                  Settings
                </span>
              ) : isMobileView &&
                window.location.pathname == "/subscriptions" ? (
                <span className="flex-center text-black font-samibold">
                  Subscriptions
                </span>
              ) : isMobileView &&
                window.location.pathname == "/notifications" ? (
                <span className="flex-center text-black font-samibold">
                  Notifications
                  {number > 0 && (
                    <span className="ml-1 text-white bg-primaryColor rounded-full px-2 py-1 text-xs font-semibold">
                      {number}
                    </span>
                  )}
                </span>
              ) : isMobileView &&
                window.location.pathname == "/buysell" &&
                location.pathname == `/${slug}/buysell` ? (
                <span className="flex-center text-black font-samibold">
                  {" "}
                  Create Order
                </span>
              ) : isMobileView && window.location.pathname == "/search" ? (
                <span className="flex-center text-black font-samibold">
                  Watchlist
                </span>
              ) : isMobileView && window.location.pathname == "/charts" ? (
                <span className="flex-center text-black font-samibold">
                  Charts
                </span>
              ) : isMobileView && window.location.pathname == "/chatHistory" ? (
                <span className="flex-center text-black font-samibold">
                  Chat History
                </span>
              ) : isMobileView && pathSegments[1] === "profile" ? (
                <span className="flex-center text-black font-samibold">
                  Profile
                </span>
              ) : isMobileView && pathSegments[1] === "performance" ? (
                <span className="flex-center text-black font-samibold">
                  Performance
                </span>
              )
              : isMobileView && pathSegments[1] === "followers" ? (
                <span className="flex-center text-black font-samibold">
                  Followers
                </span>
              ) : isMobileView && window.location.pathname == "/saved-post" ? (
                <span className="flex-center text-black font-samibold">
                  Saved Post
                </span>
              ) : isMobileView &&
                window.location.pathname == "/edit-profile" ? (
                <span className="flex-center text-black font-samibold">
                  Edit Profile
                </span>
              ) : isMobileView && pathSegments[1] === "portfolio" ? (
                <span className="flex-center text-black font-samibold">
                  Portfolio
                </span>
              ) : (
                ""
              )}
            </div>
          </p>
        </div>

        <div
          style={{
            marginLeft: location.pathname === "/feed" || window.location.pathname.includes("/feeds"),
          }}
          className="avaterSection flex items-center gap-2 sm:gap-6 text-slate-400"
        >
          <div
            className={`flex flex-row gap-4 justify-between ${
              isMobileView ? "" : "hidden"
            }`}
          >
            {location.pathname === "/feed" || window.location.pathname.includes("/feeds") && !isValidPath ? showAllIcons() : ""}
            {/* {[
            "/leaderboard",
            "/contest",
            '/contest/my-games',
            '/contest/add-game',
            /\/contest\/game-detail\/\d+/,
            '/contest/detail-game/:id',
            "/auth/trending-stocks",
            "/market-sentiment",
            "/create-post",
            "/notifications",
            // "/buysell",
            "/search",
            "/charts",
            "/traderprofile",
            "/saved-post",
            "/edit-profile",
            "/change-password",
          ].includes(location.pathname) && showToggleOnly()} */}
            {[
              "/leaderboard",
              "/contest",
              "/trading-floor",
              "/contest/my-games",
              "/contest/cash-leagues",
              "/contest/add-league",
              "/auth/trending-stocks",
              "/market-sentiment",
              "/create-post",
              "/notifications",
              "/search",
              "/charts",
              "/traderprofile",
              "/saved-post",
              "/edit-profile",
              "/change-password",
            ].includes(location.pathname) ||
            /\/contest\/game-detail\/\d+/.test(location.pathname) ||
            /^\/contest\/[^/]+$/.test(window.location.pathname) ||
            window.location.pathname == `/contest/${slug}/edit`
              ? showToggleOnly()
              : null}
            {pathSegments[1] === "chartSearch" ? showToggleOnly() : ""}
            {pathSegments[1] === "edit-post" ? showChatAndToggleOnly() : ""}
            {pathSegments[1] === "paid-content" ? showChatAndToggleOnly() : ""}
            {pathSegments[1] === "profile" ? showChatAndToggleOnly() : ""}
            {pathSegments[1] === "buysell" ? showToggleOnly() : ""}
            {pathSegments[1] === "chatHistory" ? showChatAndToggleOnly() : ""}
            {pathSegments[1] === "portfolio" ? showChatAndToggleOnly() : ""}

            {["/subscriptions", "/settings", "/chat"].includes(
              location.pathname
            ) && showChatAndToggleOnly()}
          </div>
          {isMobileView ? null : (
            <Link to="/profile">
              <img
                className="object-cover rounded-full md:h-10 md:w-10 h-10 w-10 border cursor-pointer"
                src={
                    isTradingDetail || !avtar && !localStorage.getItem("img")
                      ? "/qushi_logo.png"
                      : avtar || localStorage.getItem("img") || "/qushi_logo.png"
                  }
                alt="Avatar"
              />
            </Link>
          )}

          <div className="hidden md:flex flex-row gap-4 text-xl">
            <Link to="/notifications">
              <div style={{ position: "relative" }}>
                <img
                  style={{ width: "22px", height: "26px" }}
                  src={require("../../images/notification-qushi.png")}
                  alt="Avatar"
                />
                {/* <FontAwesomeIcon icon={faBell}></FontAwesomeIcon> */}
                {number > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0.25rem",
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      lineHeight: 1,
                      color: "#fff",
                      // backgroundColor: "#B69D31",
                      borderRadius: "50px",
                      transform: "translate(50%, -50%)",
                      width: "19px",
                    }}
                    className="bg-primaryColor"
                  >
                    {number}
                  </span>
                )}
              </div>
            </Link>
            <div style={{ position: "relative" }}>
              <Link to="/chat">
                <img
                  style={{ width: "26px", height: "26px" }}
                  src={require("../../images/msg-qushi.png")}
                  alt="Avatar"
                />
                {/* <FontAwesomeIcon icon={faComments}></FontAwesomeIcon> */}
                {messageCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0.25rem",
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      lineHeight: 1,
                      color: "#fff",
                      borderRadius: "50px",
                      transform: "translate(50%, -50%)",
                      width: "19px",
                    }}
                    className="bg-primaryColor"
                  >
                    {window.location.pathname == "/chat" ? (
                      <FontAwesomeIcon icon={faPlus} />
                    ) : (
                      messageCount
                    )}
                  </span>
                )}
              </Link>
            </div>
          </div>
          {/* Language Select Dropdown */}
          {/* <div className="hidden md:flex md:flex-1">
          <div className=" flex relative justify-center items-center text-gray-700  border-l-2 px-2">
            <select
              className="w-12 rounded-md px-1 py-1 pr-1 appearance-none focus:outline-none focus:shadow-outline"
              onClick={handleLanguageChange}
            >
              <option value="en">EN</option>
              <option value="fr">FR</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 text-gray-600">
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          </div>
        </div> */}
        </div>
      </div>
      {isChartsPath && isMobileView && (
        <div className={`pl-2 pt-16 md:flex md:flex-1 justify-center`}>
          {!shouldHideTopbarSearch && (
            <TopbarSearch
              clearSearch={clearSearch}
              handleChange={handleChange}
              handleCategory={handleCategory}
              scButton={scButton}
              search={search}
              handleSubmit={handleSubmit}
              isMobileView
            />
          )}
        </div>
      )}
    </>
  );
}

export default DashboardHeader;
